import React, { useState } from "react";
import { Document, Page } from "react-pdf";
import {
  Box,
  Spinner,
  Center,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  useDisclosure,
  Text,
  useBreakpointValue,
} from "@chakra-ui/react";
import "./PdfPreview.css";

interface PdfPreviewProps {
  pdfUrl: string | undefined;
  penultimatePage: boolean;
}

const PdfPreview: React.FC<PdfPreviewProps> = ({
  pdfUrl,
  penultimatePage = false,
}) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [numPages, setNumPages] = useState<number>(1);
  const [previewPage, setPreviewPage] = useState<number>(1);
  const pageWidth = useBreakpointValue({ base: 300, md: 600 }) || 300;

  const onDocumentLoadSuccess = ({ numPages }: { numPages: number }) => {
    setNumPages(numPages);
    if (penultimatePage) setPreviewPage(numPages - 1);
  };

  return (
    <Box>
      <Box
        border="1px"
        borderColor="gray.200"
        p="2"
        cursor="pointer"
        _hover={{ boxShadow: "md" }}
        onClick={onOpen}
        width="100%"
        height="auto"
        overflow="hidden"
      >
        <Document
          file={pdfUrl}
          onLoadSuccess={onDocumentLoadSuccess}
          noData={<Text>PDF não fornecido</Text>}
          error={<Text>Erro ao carregar o PDF</Text>}
          loading={
            <Center h="200px">
              <Spinner />
            </Center>
          }
        >
          <Page
            pageNumber={previewPage}
            width={255}
            renderAnnotationLayer={false}
            renderTextLayer={false}
          />
        </Document>
      </Box>
      <Modal isOpen={isOpen} onClose={onClose} size="full" scrollBehavior="inside">
        <ModalOverlay />
        <ModalContent maxW={{ base: "95%", md: "90%" }} mx="auto" my="auto">
          <ModalHeader>Visualização do PDF</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Center flexDirection="column">
              <Document
                file={pdfUrl}
                error={<Text>Erro ao carregar o PDF</Text>}
                onLoadSuccess={onDocumentLoadSuccess}
                loading={
                  <Center h={{ base: "300px", md: "500px" }}>
                    <Spinner />
                  </Center>
                }
              >
                {penultimatePage ? (
                  <Page
                    pageNumber={previewPage}
                    width={pageWidth}
                    renderAnnotationLayer={false}
                    renderTextLayer={false}
                  />
                ) : (
                  Array.from(new Array(numPages), (_, index) => (
                    <Page
                      key={index}
                      pageNumber={index + 1}
                      width={pageWidth}
                      renderAnnotationLayer={false}
                      renderTextLayer={false}
                    />
                  ))
                )}
              </Document>
            </Center>
          </ModalBody>
        </ModalContent>
      </Modal>
    </Box>
  );
};

export default PdfPreview;
